import { useState } from "react";
import { FileUploadInput } from "@src/components/Forms/FormElements/Inputs/FileUploadInput";
import { createRowWithIntervals } from "@src/utility_functions/database_operations/rows/createRowWithIntervals";
import { FileUploadRules } from "@src/components/Forms/Rows/ImportRow/FileUploadRules";
import { ImportRowInstructionsDoordash } from "@src/components/Forms/Rows/ImportRow/Doordash/ImportRowInstructionsDoordash";
import { WaitMessage } from "@src/components/Forms/Rows/ImportRow/WaitMessage";
import type { ProcessedData } from "#root/src/types/timeline.ts";

export const ImportRowDoordash = (props) => {
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true);
  const [processedData, setProcessedData] = useState<ProcessedData | null>(
    null,
  );
  const [fileName, setFileName] = useState("");
  const fileSizeLimitMBs = 10;
  return (
    <>
      <div>
        <div className="two_column_gutter_2 _margin-right--2rem">
          <ImportRowInstructionsDoordash />
        </div>
        <div className="two_column_gutter_2">
          <form
            id="importDoordashForm"
            onSubmit={async (event) => {
              event.preventDefault();
              event.stopPropagation();
              props.setSaveButtonLoading(true);
              if (!processedData) {
                console.warn("No processed data available.");
                props.setSaveButtonLoading(false);
                return;
              }
              const serverPayload = {
                description:
                  "Total spent: $" + (processedData.totalSpent ?? 0).toFixed(2),
                intervals: JSON.stringify(processedData.intervals),
                source: "doordash",
              };
              const serverResponse =
                await createRowWithIntervals(serverPayload);

              if (serverResponse.error) {
                console.warn(serverResponse.error);
                props.setSaveButtonLoading(false);
              } else {
                window.location.href =
                  "/user/" +
                  props.loggedInUser?.id +
                  "/row/" +
                  serverResponse.payload.newRowID;
              }
            }}
          >
            <FileUploadInput
              type="doordash"
              fileSizeLimitMBs={fileSizeLimitMBs}
              loggedInUser={props.loggedInUser}
              isLoading={props.saveButtonLoading}
              setIsLoading={props.setSaveButtonLoading}
              submitButtonDisabled={submitButtonDisabled}
              setSubmitButtonDisabled={setSubmitButtonDisabled}
              setProcessedData={setProcessedData}
              fileName={fileName}
              setFileName={setFileName}
            />
            <FileUploadRules
              fileSizeLimitMBs={fileSizeLimitMBs}
              allowedFileTypes={[".csv"]}
            />
            {props.saveButtonLoading && (
              <>
                <WaitMessage />
              </>
            )}
          </form>
        </div>
      </div>
    </>
  );
};
